import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import PropertyDetail from '@/components/Elements/Loader/PropertyDetail';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './Carousel.css';
import '../PropertyProject/newProject.css';
import {
  getPropertyforRentDetails,
  usePropertyForRentDetails,
} from '@/api/propertyForRent/getPropertyforRentDetails';
import GoogleMapReact from 'google-map-react';

import { inquiryPropertyProject } from '@/api/propertyProject/inquiryPropertyProject';
import propertyCategory from '@/constants/propertyCategory';
import { useNotificationStore } from '@/stores/notifications';
import { useAuth } from '@/lib/auth';

import map from '@/assets/m-icon.png';
import town1 from '@/assets/town1.png';
import town2 from '@/assets/town2.png';
import town3 from '@/assets/town3.png';
import arrow from '@/assets/btn-arrow.png';
import solid from '@/assets/solid.png';
import arrow1 from '@/assets/arrow.png';
import buildng from '@/assets/building-solid.png';
import calendr from '@/assets/calendar.png';
import vector from '@/assets/Vector.png';
import chat1 from '@/assets/chat2.png';

import mimg2 from '@/assets/m-icon2.png';
import time from '@/assets/Time_light.png';
import atom from '@/assets/Atom_light.png';
import bcase from '@/assets/briefcase.png';
import book from '@/assets/book.png';

import ck1 from '@/assets/check1.jpg';
import pop from '@/assets/popular.png';
import be from '@/assets/bed.png';
import ba from '@/assets/bath.png';
import FsImageOpner from '@/components/FsImageOpner/FsImageOpner';
import storage from '@/utils/storage';
import i18next from 'i18next';
import { translateAmenties } from '@/translations/translateFunction';

import { useBusinessDetails } from '@/api/commonDetail/getBusinessDetail';
import { useLatestRentProperty } from '@/api/propertyForRent/getLatestRentProperty';
import Slider from 'react-slick';
import { Listing } from '@/types';
import { axios2 } from '@/lib/axios';
import { createChat } from '@/api/Chat/createChat';
import { Button } from '@/components/Elements';
import { SendMessage } from '../SendMessage/sendMessage';
import { formatPrice } from '@/utils/format';
import { formatAmount } from '../NewHomePage/HomePage';

function PropertyContent() {
  const [img1, setImg1] = useState();
  const [img2, setImg2] = useState();
  const [img3, setImg3] = useState();
  const [show, setShow] = useState(false);

  const AnyReactComponent = ({ lat, lng, text }: { lat: any; lng: any; text: any }) => (
    <div>{text}</div>
  );
  const { user } = useAuth();
  const localCurrency = storage.getAmount();
  const localSymbol = storage.getSymbol();
  const { id }: any = useParams();
  const searchParams = new URLSearchParams(document.location.search);
  const typeVal = searchParams.get('type');
  const {
    data,
    isLoading,
    refetch: refetchProperty,
  } = useBusinessDetails({ id: id ?? '2', customer_id: user?.customer_id ?? '' });

  const {
    data: latestProperty,
    isLoading: latestLoading,
    refetch,
  } = useLatestRentProperty({ id: id ?? '' });

  // const { data, isLoading } = usePropertyForRentDetails({ id: id ?? '2' });
  const property = data?.data;
  const customerId = data?.data?.customer_id;
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL as string;

  const navigate = useNavigate();
  // const property = {};
  const [iLat, setiLat] = useState<number>();
  const [iLong, setiLong] = useState<number>();
  useEffect(() => {
    if (property) {
      const parsed_data = property?.image_data;
      setImg1(parsed_data[0]);
      setImg2(parsed_data[1]);
      setImg3(parsed_data[2]);

      const parsedLat = parseFloat(property.latitude);
      const parsedLong = parseFloat(property.longitude);

      if (!isNaN(parsedLat) && !isNaN(parsedLong)) {
        setiLat(parsedLat);
        setiLong(parsedLong);
      } else {
        console.log('Invalid latitude or longitude values');
      }
    }
  }, [property]);
  // const categoryVal = property?.category;
  // const amenitiesValues = property?.amenities ?? '';
  // const amenitiesArray = amenitiesValues.split(',');

  type inquiryAd = {
    name: string;
    telephone: string;
    email: string;
    message: string;
    company_name: string;
  };
  const [loading, setLoading] = useState(false);
  const [toggler, setToggler] = useState<boolean>(false);
  const [pics, setPics] = useState<string[]>([]);
  const [productIndex, setProductIndex] = useState(0);

  const options = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    dots: false,
    autoplay: true,
    navText: ['<', '>'],
    rewind: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };
  const optionsCar = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    dots: false,
    autoplay: true,
    navText: ['<', '>'],
    rewind: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 2,
      },
      400: {
        items: 3,
      },
      600: {
        items: 4,
      },
      700: {
        items: 5,
      },
      1000: {
        items: 5,
      },
    },
  };
  const optionsThree = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    dots: false,
    autoplay: true,
    navText: ['<', '>'],
    rewind: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      600: {
        items: 2,
      },
      700: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  };

  // useEffect(() => {
  //   eval(property?.image_data)?.map((val: string) => {
  //     setPics((item) => [...item, val]);
  //   });
  // }, [isLoading, loading]);

  useEffect(() => {
    const video: string = property?.video ?? '';
    setPics([video]);
    const images = eval(property?.image_data);
    if (images && Array.isArray(images)) {
      images.forEach((val: string) => {
        setPics((prevPics) => [...prevPics, val]);
      });
    }
  }, [isLoading]);

  const handleToggler = (index: number) => {
    setToggler(true);
    setProductIndex(index);
  };

  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  useEffect(() => {
    setToggler(false);
  }, [isLightboxOpen]);

  const settings = {
    dots: true,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: latestProperty && latestProperty?.length < 4 ? latestProperty?.length : 4,
    slidesToScroll: 1,
    autoplay: true,
    // autoplaySpeed: 5000,
    cssEase: 'linear',
  };

  const handleFavorite = async (event: any, id: string, isFavourite: any) => {
    event.stopPropagation();
    if (!user) {
      useNotificationStore.getState().addNotification({
        title: 'Login',
        type: 'info',
        message: 'Need to Login first!',
      });
      navigate('/auth/login-user');
      return;
    }
    const apiUrl = `/panel-api/favourite-unfavourite-rent-property`;

    try {
      const response = await axios2.post(apiUrl, {
        rent_id: id,
        status_action: !isFavourite,
      });

      useNotificationStore.getState().addNotification({
        title: `${!isFavourite ? 'Added Favorite' : 'Removed Favorite'}`,
        type: 'success',
        message: `Successfully ${!isFavourite ? 'added to' : 'removed from'} favorites`,
      });

      refetch();
    } catch (error) {
      console.error('Failed to update favorite status:', error);

      useNotificationStore.getState().addNotification({
        title: 'Error',
        type: 'error',
        message: 'Failed to update favorite status. Please try again.',
      });
    }
  };
  const copyLinkToClipboard = (event: any, id: number) => {
    event.stopPropagation();
    let url = `/property-for-rent-detail/${id}?type=RentProperty`;
    let sharelink = `${frontendUrl + url}`;
    navigator.clipboard
      .writeText(sharelink)
      .then(() => {
        useNotificationStore.getState().addNotification({
          title: 'Copied!',
          type: 'success',
          message: 'Link copied to clipboard.',
        });
      })
      .catch((err) => {
        console.error('Failed to copy link:', err);
      });
  };

  useEffect(() => {
    setLoading(true);
    if (id) {
      refetch();
      refetchProperty();
      setLoading(false);
    }
  }, [id]);

  const handleChat = async () => {
    try {
      if (!user) {
        useNotificationStore.getState().addNotification({
          title: 'Login',
          type: 'info',
          message: 'Need to Login first!',
        });
        navigate('/auth/login-user');
        return;
      }

      const res: any = await createChat(property?.customer_id);
      navigate(`/user/chat?id=${property?.customer_id}&sid=${res?.twilio_channel_sid}`);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {isLoading || loading ? (
        <PropertyDetail />
      ) : (
        <div className="Content project-prop-details ">
          <FsImageOpner
            pics={pics}
            index={productIndex}
            show={toggler}
            // setIsLightboxOpen={setIsLightboxOpen}
          />

          {/* {eval(property?.image_data)?.length == 0 ? null : (
            <>
              <div className="container ">
                <div className="row">
                  <div className="col-md-12 col-12">
                    <div className="propertyCarousel noter prop-cont">
                      <OwlCarousel {...options} className="owl-theme" loop nav>
                        {eval(property?.image_data)?.map((item: any, index: number) => (
                          <div key={index}>
                            <div className="item">
                              {item?.name && <span className="imageNames">{item?.name}</span>}
                              <img alt="hias" src={item?.image} />
                            </div>
                          </div>
                        ))}
                      </OwlCarousel>
                    </div>
                  </div>

                  <div className="col-md-12 col-12 row picsfor fiveBOxes prop-content">
                    {property?.image_data?.length <= 4 ? (
                      <>
                        {eval(property?.image_data)
                          .slice(0, 4)
                          .map((item: any, index: number) => (
                            <div className="col-md-3 col-6" key={index}>
                              <img
                                alt="hixas"
                                src={item?.image}
                                onClick={() => handleToggler(index)}
                              />
                            </div>
                          ))}
                      </>
                    ) : (
                      <OwlCarousel {...optionsCar} className="owl-theme" loop nav>
                        {eval(property?.image_data)?.map((item: any, index: number) => {
                          return (
                            <div key={index}>
                              <div className="item">
                                <img
                                  alt="hias"
                                  src={item?.image}
                                  onClick={() => handleToggler(index)}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </OwlCarousel>
                    )}
                  </div>

                  <FsImageOpner
                    pics={pics}
                    index={productIndex}
                    show={toggler}
                    setIsLightboxOpen={setIsLightboxOpen}
                  />
                </div>
              </div>
            </>
          )} */}

          <section className="space">
            <div className="properties-main mt-5 pt-5 ">
              <div className="container relative">
                {property?.customer_id !== user?.customer_id && (
                  <div className="col-12 d-flex justify-content-end pb-4">
                    <Button
                      className="black-btn bg-black"
                      size="sm"
                      disabled={property?.is_requested}
                      onClick={(e) => {
                        if (!user) {
                          useNotificationStore.getState().addNotification({
                            title: 'Login',
                            type: 'info',
                            message: 'Need to Login first!',
                          });
                          navigate('/auth/login-user');
                          return;
                        }
                        setShow(true);
                      }}
                    >
                      Send Message
                    </Button>
                  </div>
                )}
                <div className="banner-sec">
                  <div className="row">
                    <div className="col-md-3 pe-0 align-content-end">
                      <div className="main-heading-content">
                        <div className="col-md-10">
                          <div className="bed-room bg-main-dark p-2 ">
                            <h5 className="text-white mb-0">{property?.title}</h5>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="Potential-room  bg-main-dark  p-2">
                            <h5 className="text-white  border p-1 rounded  mb-0">
                              Potential Of {localSymbol}
                              {formatAmount(formatPrice(property?.monthly_rent * localCurrency))} PA
                            </h5>
                          </div>
                        </div>
                        <div className="col-md-10">
                          <div className="location-box bg-main-dark p-2  d-flex align-items-center gap-2 mb-1">
                            <div className="m-icon">
                              <img src={map} alt="pay1" />
                            </div>
                            <p className="text-white mb-0">
                              {property?.house_number ?? ''} {property?.house_number && ','}{' '}
                              {property?.landmark ?? ''} {property?.landmark && ','}{' '}
                              {property?.location}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="discover-box bg-main-light rounded-4 p-4 ">
                        <p className="text-white mb-0 ">{property?.description}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="pro-banner h-100 ">
                        <img src={img1} alt="pay1" className="h-100" />
                      </div>
                    </div>
                    <div className="col-md-3 ps-0">
                      <div className="Explore-box bg-main-dark rounded-4 p-4 mb-3">
                        <h5 className="border-bottom wmc pb-1 text-white">Property Overview</h5>
                        <p className="text-white mb-0">{property?.property_overview}</p>
                      </div>
                      <div className="banner-box-2 mb-3">
                        <div className="b-img-2">
                          <img src={img2} alt="pay1" />
                        </div>
                      </div>
                      <div className="banner-box-3">
                        <div className="b-img-3 position-relative">
                          <img src={img3} alt="pay1" />
                          <div className="view-btn btn-bg rounded-30 wmc">
                            <button
                              type="button"
                              className="btn d-flex align-itmes-center"
                              onClick={() => {
                                setToggler(!toggler);
                              }}
                            >
                              View All{' '}
                              <span className="ps-2">
                                <img src={arrow} alt="arrow" />
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="town-section">
                  <div className="row">
                    <div className="col-md-5 mx-auto">
                      <div className="town-content shadow bg-white p-2 rounded-10">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="town-details  town-bg p-2">
                              <div className="town-img">
                                <img src={town1} alt="pay1" />
                              </div>
                              <div className="town-text">
                                <h6 className="mb-0 light-color fs-14">City</h6>
                                <p className="mb-0 text-black">{property?.city}</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="town-details  town-bg p-2">
                              <div className="town-img">
                                <img src={town2} alt="pay1" />
                              </div>
                              <div className="town-text">
                                <h6 className="mb-0 light-color fs-14">State</h6>
                                <p className="mb-0 text-black">{property?.state}</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="town-details  town-bg p-2">
                              <div className="town-img">
                                {/* <img src={town3} alt="pay1" /> */}
                                <img src={town3} alt="pay1" />
                              </div>
                              <div className="town-text">
                                <h6 className="mb-0 light-color fs-14">Phone Number</h6>
                                <p className="mb-0 text-black">{property?.customer_phone_number}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="facelities mt-5">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="facelities-left face-bg p-3 rounded-10">
                      <h5 className="text-black">Facilities</h5>
                      <div className="facelities-box-flex d-flex align-items-center gap-4">
                        {/* <div className="facelities-box pe-4 dropdown ">
                          <button className="dropbtn">
                            <div className="living-img  ">
                              <img src={home} alt="living" />
                            </div>
                            <p className="mb-0 text-black fs-12">Living Spaces</p>
                          </button>
                          <div className="dropdown-content rounded-15 shadow">
                            <div className="sub-menu">
                              <a href="#">
                                <span>
                                  {' '}
                                  <img src={sb1} alt="home" />
                                </span>
                                Garden View
                              </a>
                              <a href="#">
                                <span>
                                  {' '}
                                  <img src={sb2} alt="home" />
                                </span>
                                Large windows
                              </a>
                              <a href="#">
                                {' '}
                                <span>
                                  {' '}
                                  <img src={sb3} alt="home" />
                                </span>
                                Balcony
                              </a>
                              <a href="#">
                                {' '}
                                <span>
                                  {' '}
                                  <img src={sb4} alt="home" />
                                </span>
                                Pets allowed
                              </a>
                            </div>
                          </div>
                        </div> */}

                        {property?.facilites?.map((i: { name: string; image: string }) => {
                          return (
                            <div className="facelities-box pe-4  ">
                              <div className="living-img  ">
                                <img src={i.image} alt="living" height={80} width={80} />
                              </div>
                              <p className="mb-0 text-black fs-12">{i.name}</p>
                            </div>
                          );
                        })}

                        {/* <div className="facelities-box pe-4 ">
                          <div className="living-img  ">
                            <img src={home} alt="living" />
                          </div>
                          <p className='mb-0 text-black fs-12'>Miscellaneous</p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="investment-left face-bg p-3 rounded-10">
                      <h5 className="text-black">Rental Information</h5>
                      <div className="investment-box-flex d-flex align-items-center gap-3">
                        <div className="investment-box pe-4 ">
                          <div className="price-text ">
                            <p className="mb-0 light-color fs-12">Monthly Rent</p>
                          </div>
                          <p className="mb-0 text-black fs-12">
                            {localSymbol}
                            {formatAmount(formatPrice(property?.monthly_rent * localCurrency))}
                          </p>
                        </div>
                        <div className="investment-box pe-4  ">
                          <div className="price-text ">
                            <p className="mb-0 light-color fs-12">Deposit</p>
                          </div>
                          <p className="mb-0  text-black  fs-12">
                            {localSymbol}
                            {formatAmount(formatPrice(property?.deposit ?? 50 * localCurrency))}
                          </p>
                        </div>
                        <div className="investment-box pe-4 ">
                          <div className="price-text ">
                            <p className="mb-0 light-color fs-12">
                              or NOK 480 per month with deposit
                            </p>
                          </div>
                          <p className="mb-0 text-black fs-12">guarantee</p>
                        </div>
                        {/* <div className="investment-box pe-4 ">
                          <div className="price-text ">
                            <p className="mb-0 light-color fs-12">Finder Fees</p>
                          </div>
                          <p className="mb-0 text-black fs-12">£66</p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="facelities-list-map mt-5 pt-5">
                  <div className="row ">
                    <div className="col-md-7">
                      <h5 className="text-black">About the home</h5>

                      <div className="facelities-listing-text">
                        <p>{property?.description_home}</p>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="map-img-right bg-white rounded-20 shadow p-2">
                        {/* <img src={mimg} alt="map" className="h-100  rounded-20" /> */}
                        <div className="rounded-10" style={{ height: '300px', width: '100%' }}>
                          <GoogleMapReact
                            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
                            defaultCenter={{ lat: iLat, lng: iLong }}
                            defaultZoom={13}
                          >
                            <AnyReactComponent
                              lat={iLat}
                              lng={iLong}
                              text={
                                <i className="fa-sharp fa-solid fa-location-dot googleEarth"></i>
                              }
                            />
                          </GoogleMapReact>
                        </div>

                        <div className="location-box  p-2  d-flex align-items-center gap-2 mt-2 ">
                          <div className="m-icon">
                            <img src={mimg2} alt="pay1" />
                          </div>
                          <p className=" mb-0">
                            {' '}
                            {property?.house_number ?? ''} {property?.house_number && ','}{' '}
                            {property?.landmark ?? ''} {property?.landmark && ','}{' '}
                            {property?.location}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="facelities-list-map key-info mt-5 pt-5">
              <div className="container">
                <div className="row ">
                  <div className="col-md-7">
                    <h5 className="text-black">Key Information</h5>
                    <div className="facelities-listing-text">
                      <div className="investment-box-flex d-flex align-items-center gap-3">
                        <div className="investment-box pe-4 ">
                          <div className="price-text ">
                            <img src={arrow1} alt="primary" />
                            <p className="mb-0 text-black fs-12">
                              {formatAmount(property?.primary_room)}
                            </p>
                          </div>
                          <p className="mb-0 light-color fs-12">Primary Room</p>
                        </div>

                        <div className="investment-box pe-4  ">
                          <div className="price-text ">
                            <img src={buildng} alt="housing" />
                            <p className="mb-0 text-black fs-12">{property?.housing_type}</p>
                          </div>
                          <p className="mb-0 light-color fs-12">Housing Type</p>
                        </div>

                        <div className="investment-box pe-4  ">
                          <div className="price-text ">
                            <img src={vector} alt="bedroom" />
                            <p className="mb-0 text-black fs-12">
                              {formatAmount(property?.key_info_bedroom)}
                            </p>
                          </div>
                          <p className="mb-0 light-color fs-12">Bedroom</p>
                        </div>

                        <div className="investment-box pe-4  ">
                          <div className="price-text ">
                            <img src={calendr} alt="period" />
                            <p className="mb-0 text-black fs-12">{property?.rental_period}</p>
                          </div>
                          <p className="mb-0 light-color fs-12">Rental Period</p>
                        </div>

                        <div className="investment-box pe-4  ">
                          <div className="price-text">
                            <img src={solid} alt="period" />
                            <p className="mb-0 text-black fs-12">{formatAmount(property?.story)}</p>
                          </div>
                          <p className="mb-0 light-color fs-12">Story</p>
                        </div>

                        {/* <div className="investment-box pe-4  ">
                          <div className="price-text ">
                            <p className="mb-0 light-color fs-12">Deposit</p>
                          </div>
                          <p className="mb-0  text-black  fs-12">NOK{property?.deposit ?? 50} </p>
                        </div> */}
                      </div>{' '}
                    </div>
                  </div>

                  <div className="conditions-bx col-md-5">
                    <h5 className=" text-black">Property Information</h5>
                    <div className="pocket-text">
                      <div className="time-img d-flex align-items-center justify-content-between my-3">
                        <p className="mb-0 first">What floor is the home on </p>
                        <p className="text-black"> {formatAmount(property?.floor)}</p>
                      </div>

                      <div className="time-img d-flex justify-content-between my-3">
                        <p className="mb-0 first">How many bedrooms</p>
                        <p className="text-black">{formatAmount(property?.bedrooms)}</p>
                      </div>

                      <div className="time-img d-flex justify-content-between my-3">
                        <p className="mb-0 first">How big is the home</p>
                        <p className="text-black">{formatAmount(property?.size)}</p>
                      </div>

                      <div className="time-img d-flex justify-content-between my-3">
                        <p className="mb-0 first">Monthly rent includes</p>
                        <p className="text-black">{property?.monthly_rent_includes?.toString()}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="meet-host mt-5">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <div className="meet-man">
                      <img src={property?.customer_images} alt="man" />
                    </div>
                  </div>
                  <div className="col-md-8 ps-5">
                    <div className="man-text bg-white rounded-20 shadow p-4">
                      <h5 className="text-black">Meet Your Host</h5>
                      <h5 className="dark-color">Polly Pocket</h5>
                      <div className="pocket-text">
                        <div className="time-img d-flex align-items-center gap-3 my-3">
                          <span>
                            <img src={time} alt="time" />
                          </span>
                          <p className="mb-0">I spend too much time: {property?.spend_time}</p>
                        </div>
                        <div className="time-img d-flex align-items-center gap-3 my-3">
                          <span>
                            <img src={atom} alt="time" />
                          </span>
                          <p className="mb-0">Most useless skill: {property?.useless_skill}</p>
                        </div>
                        <div className="time-img d-flex align-items-center gap-3 my-3">
                          <span>
                            <img src={bcase} alt="time" />
                          </span>
                          <p className="mb-0">Fun fact: {property?.fun_act}</p>
                        </div>
                        <div className="time-img d-flex align-items-center gap-3">
                          <span>
                            <img src={book} alt="time" />
                          </span>
                          <p className="mb-0">My biography title: My Bio</p>
                        </div>
                        <p className="mb-0 mt-3">{property?.biography}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="meet-host mt-5">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <div className="man-text bg-white rounded-20 shadow p-4">
                      <h5 className="text-black">Other Info</h5>
                      <div className="pocket-text">
                        <div className="time-img d-flex align-items-center justify-content-between my-3">
                          <p className="mb-0">Heading: </p>
                          <p className="text-black"> {property?.heading}</p>
                        </div>

                        <div className="time-img d-flex justify-content-between my-3">
                          <p className="mb-0">Display Information:</p>
                          <p className="text-black">{property?.display_information}</p>
                        </div>

                        <div className="time-img d-flex justify-content-between my-3">
                          <p className="mb-0">Name of the ad:</p>
                          <p className="text-black">{property?.name_of_ad}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 ps-5">
                    <div className="man-text bg-white rounded-20 conditions-bx shadow p-4">
                      <h5 className="text-black">Conditions</h5>
                      <div className="pocket-text">
                        <div className="time-img d-flex align-items-center justify-content-between my-3">
                          <p className="mb-0 first">Rental Period: </p>
                          <p className="text-black"> {property?.rental_period}</p>
                        </div>

                        <div className="time-img d-flex justify-content-between my-3">
                          <p className="mb-0 first">Available from date:</p>
                          <p className="text-black">{property?.avaiable_from_date}</p>
                        </div>

                        <div className="time-img d-flex justify-content-between my-3">
                          <p className="mb-0 first">Monthly Rent:</p>
                          <p className="text-black">
                            {localSymbol}
                            {formatAmount(formatPrice(property?.monthly_rent * localCurrency))}
                          </p>
                        </div>

                        <div className="time-img d-flex justify-content-between my-3">
                          <p className="mb-0 first">Security:</p>
                          <p className="text-black">{property?.security?.toString()}</p>
                        </div>

                        <div className="time-img d-flex justify-content-between my-3">
                          <p className="mb-0 first">Security Amount:</p>
                          <p className="text-black">
                            {localSymbol}
                            {formatAmount(formatPrice(property?.security_amount * localCurrency))}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 ps-5">
                    <div className="man-text bg-white rounded-20 shadow benefit-bs p-4">
                      <h5 className="text-black">Benefits</h5>
                      <div className="pocket-text">
                        {/* {property?.benefits.map((benefit, index) => (
                          <div key={index} className="time-img d-flex justify-content-between my-3">
                            <p className="mb-0">{benefit}</p>
                          </div>
                        ))} */}

                        {property?.benefits?.map((i: any) => {
                          return (
                            <div className="p-2">
                              <div className="uni-img d-flex align-items-center gap-2">
                                <img src={town2} alt="univer" className=" " width={20} />
                                <h5 className="text-black mb-0 fs-16">{i}</h5>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="check-out-new mb-5">
              <div className="container">
                <div className="row">
                  <div className="col-md-8">
                    <h6 className="mb-0 dark-color mt-3">CHECKOUT OUR NEW</h6>
                    <h4 className="mb-0 mt-3 mb-3">Latest Listed Properties</h4>
                    <p className="mb-0">
                      Explore the newest properties on the market, offering modern amenities and
                      prime locations.
                    </p>
                  </div>
                  <div className="check-img mt-5">
                    <div className="row">
                      <Slider {...settings}>
                        {latestProperty?.map((val: Listing) => {
                          return (
                            <div className="col-md-3">
                              <div className="item-box deals-page">
                                <div
                                  className="check1 pointer"
                                  onClick={() => {
                                    navigate(
                                      `/property-for-rent-detail/${val?.id}?type=RentProperty`
                                    );
                                    window.scroll({
                                      top: 0,
                                      behavior: 'smooth',
                                    });
                                  }}
                                >
                                  <img
                                    src={val?.image_data[0] ?? ck1}
                                    alt="univer"
                                    className="check-1 "
                                  />
                                  <h5 className="dark-gray mt-4">$ {val?.monthly_rent}</h5>
                                  <h6 className="dark-gray mb-1">{val?.title}</h6>
                                  <p className="f-13 mb-2">{val?.location}</p>
                                  <div className="bed-bath d-flex align-items-center gap-3">
                                    <div className="bed d-flex align-items-center gap-2">
                                      <img src={be} alt="bed" width={20} />
                                      <p className="mb-0">{val?.bedrooms} Beds</p>
                                    </div>
                                    {/* <div className="bath d-flex align-items-center gap-2">
                                      <img src={ba} alt="bed" />
                                      <p className="mb-0">3 Bath</p>
                                    </div> */}
                                  </div>
                                  {/* <div className="pop-btn btn-bg rounded-30 wmc">
                                    <button
                                      type="button"
                                      className="btn d-flex align-items-center dark-color fw-500"
                                    >
                                      <span className="pe-2">
                                        <img src={pop} alt="popular" />{' '}
                                      </span>{' '}
                                      Popular{' '}
                                    </button>
                                  </div> */}
                                  <div className="heart-icon">
                                    <span
                                      className="pointer"
                                      onClick={(e) => handleFavorite(e, val.id, val.favourite)}
                                    >
                                      <i
                                        className={`fa-heart ${
                                          val.favourite ? 'fa-solid text-danger' : 'fa-regular'
                                        }`}
                                      ></i>
                                    </span>

                                    <span
                                      onClick={(e) => copyLinkToClipboard(e, val.id)}
                                      className="pointer"
                                    >
                                      <i className="fa-solid fa-reply rotate ps-2"></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* {property?.customer_id !== user?.customer_id && (
            <div className="chat-icon">
              <div onClick={() => handleChat()} className="chat-button-fix pointer">
                <img src={chat1} className="chat-fil" />
              </div>
            </div>
          )} */}

          <SendMessage
            propType="rent_property"
            propId={id}
            userId={property?.customer_id}
            show={show}
            setShow={setShow}
            refetch={refetchProperty}
          />
        </div>
      )}
    </>
  );
}

export default PropertyContent;
